<template>
  <div>
    <div v-if="permission.access">
    <div class="data-table-title">
      <div class="data-table-description">
        インポートの履歴を確認できます。直近のインポート20件のみが表示されます。
      </div>
    </div>
    <div class="data-table-message" :class="header_notification ? 'header-notification-space-120' : ''">
      <div class="data-table-th-ellipsis">インポートファイル名</div>
      <div class="data-table-th-80">SNS</div>
      <div class="data-table-th-120">ステータス</div>
      <div class="data-table-th-120" v-if="activate == 20 && admin_mode">インポートID</div>
      <div class="data-table-th-160" v-if="activate == 20 && admin_mode">クライアント名</div>
      <div class="data-table-th-80">件数</div>
      <div class="data-table-th-80">インポート可</div>
      <div class="data-table-th-80">インポート不可</div>
      <div class="data-table-th-140">インポート日時</div>
      <div class="data-table-th-120"></div>
    </div>
    <div class="data-table-th-loading" v-loading="loading" v-if="loading"></div>
    <div class="data-table-list-nolist" v-if="no_import && !loading">
      <img src="../../assets/import.png" style="opacity:0.5" alt />
      <div style="font-size:20px; font-weight:700; margin-bottom:15px;">インポート履歴がありません</div>
      <div class="data-table-list-nolist-content">新規インポートは[新規リクエスト・インポート]タブから行えます</div>
    </div>
    <div v-if="!loading">
      <div
        v-for="import_item in import_list"
        :key="import_item.import_id"
        class="data-table-list-tr"
        :style="import_item.import_status == 'importing' ? 'opacity:0.5; cursor:pointer' : ''"
        @click="import_item.import_status == 'importing' ? loadImport(false) : ''"
      >
        <div class="data-table-th-ellipsis column" style="margin-right:20px">
          <div>{{ import_item.import_name }}</div>
          <div v-if="import_item.import_status == 'importing'">インポートを実行中です({{ import_item.import_progress }}%) - クリックでインポート状況を更新</div>
        </div>
        <div class="data-table-th-80">
          <img src="../../assets/ig_icon.png" alt v-if="import_item.sns_type == 'instagram'" class="data-table-sns-icon" style="opacity: 0.7" />
          <img src="../../assets/yt_icon.png" alt v-if="import_item.sns_type == 'youtube'" class="data-table-sns-icon" style="opacity: 0.7" />
          <img src="../../assets/tt_icon.png" alt v-if="import_item.sns_type == 'tiktok'" class="data-table-sns-icon" style="opacity: 0.7" />
          <img src="../../assets/tw_icon.png" alt v-if="import_item.sns_type == 'twitter'" class="data-table-sns-icon" style="opacity: 0.7" />
        </div>
        <div class="data-table-th-120">{{ import_item.import_status == "imported" ? "インポート済み" : "インポート中" }}</div>
        <div class="data-table-th-120" v-if="activate == 20 && admin_mode">{{ import_item.import_id }}</div>
        <div class="data-table-th-160" v-if="activate == 20 && admin_mode">{{ import_item.client_name }}</div>
        <div class="data-table-th-80">{{ import_item.import_num }}</div>
        <div class="data-table-th-80">{{ import_item.exist_num }}</div>
        <div class="data-table-th-80">{{ import_item.noexist_num }}</div>
        <div class="data-table-th-140">{{ import_item.imported_at }}</div>
        <div class="data-table-th-120">
          <el-button type="info" size="small" @click.stop="deleteImport(import_item.import_id)">削除</el-button>
        </div>
      </div>
    </div>
    </div>
    <unpermitted v-else />
  </div>
</template>

<script>
import unpermitted from "./../unpermitted"
const root = process.env.VUE_APP_API;
const loadImportAPI = root + "/api/import/load_import";
const deleteImportAPI = root + "/api/import/delete_import";

export default {
  name: "requestHistory",
  props: [],
  components: {
    unpermitted
  },
  data() {
    return {
      loading: false,
      no_import: false,
      import_list: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.import;
    },
    activate() {
      return this.$store.state.activate;
    },
    admin_mode() {
      return this.$store.state.admin_mode;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
  },
  mounted() {
    this.loadImport(true);
  },
  methods: {
    loadImport(loading) {
      if (loading) this.loading = true;
      this.no_import = false;
      this.axios
        .get(loadImportAPI, {
          params: {
            token: this.token,
            mode: this.admin_mode ? "admin_mode" : "",
          },
        })
        .then((response) => {
          this.import_list = response.data.note_import;
          if (this.import_list.length == 0) {
            this.no_import = true;
          }
          setTimeout(() => {
            this.loading = false;
          }, 300);
        })
        .catch(() => {
          this.no_import = true;
          this.loading = false;
        });
    },
    deleteImport(import_id) {
      this.$confirm("インポート履歴を削除すると、インポートされたデータ(パーソナルデータ/ノート/カスタマイズタグ)も全て削除されます。<br/>この操作は取り消せません。", "インポート履歴の削除", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "削除",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("import_id", import_id);
          this.axios
            .post(deleteImportAPI, params)
            .then(() => {
              this.$alert("インポート履歴を削除しました", {
                confirmButtonText: "OK",
                showCancelButton: false,
                type: "success",
              });
              this.loadImport(true);
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
};
</script>
